<form
  #conditionsFormTemplate="ngForm"
  class="loren-automation-plan-grid-form loren-automation-plan-conditions-add"
  [formGroup]="conditionForm"
  [ngClass]="{
    'loren-automation-plan-conditions-add': mode === 'adding',
    'loren-automation-plan-conditions-edit': mode === 'editing',
    'loren-automation-plan-conditions-delete': mode === 'deleting'
  }"
  (submit)="submitForm()">
  <mat-form-field
    required
    appearance="outline"
    class="loren-form-field loren-form-field-automation-plan loren-automation-plan-grid-full-width"
    [ngClass]="{
      'loren-form-field-automation-plan--with-value': selectedAssetIdField.value
    }"
    [hideRequiredMarker]="false">
    <mat-label>{{
      "automation_plans_form.select_asset" | transloco
    }}</mat-label>

    <mat-select
      formControlName="selectedAssetId"
      [compareWith]="compareAsset"
      [value]="selectedAssetIdField.value || ''">
      @for(asset of allAssets; track asset) {
      <mat-option [value]="asset">{{ asset.name }}</mat-option>
      }
    </mat-select>
    <mat-error>{{ "automation_plans_form.no_asset" | transloco }}</mat-error>
    @if(selectedAssetIdField.value) {
    <mat-icon matSuffix class="loren-automation-plan-edit"> edit </mat-icon>
    }
  </mat-form-field>
  @if(conditionsOptions?.length) {
  <mat-form-field
    required
    appearance="outline"
    class="loren-form-field loren-form-field-automation-plan loren-automation-plan-grid-full-width"
    [ngClass]="{
      'loren-form-field-automation-plan--with-value':
        selectedConditionField.value
    }">
    <mat-label>{{
      "automation_plans_form.select_condition" | transloco
    }}</mat-label>
    <mat-select
      formControlName="selectedCondition"
      [compareWith]="compareCondition"
      [value]="selectedConditionField.value || ''">
      @for(option of conditionsOptions; track option) {
      <mat-option [value]="option"
        >{{ $safeNavigationMigration(option?.key) | transloco }} ({{ option?.metering }})</mat-option
      >
      }
    </mat-select>
    <mat-error>{{
      "automation_plans_form.no_condition" | transloco
    }}</mat-error>
    @if(selectedConditionField.value) {
    <mat-icon matSuffix class="loren-automation-plan-edit"> edit </mat-icon>
    }
  </mat-form-field>
  @if(selectedConditionField.value?.value &&
  !isConditionBinary($safeNavigationMigration(selectedConditionField.value?.value)) &&
  !isConditionGeofence($safeNavigationMigration(selectedConditionField.value?.value))) {
  <mat-form-field
    required
    appearance="outline"
    class="loren-form-field loren-form-field-automation-plan"
    [ngClass]="{
      'loren-form-field-automation-plan--with-value': alarmValueField.value
  }">
    <mat-label>{{ "automation_plans_form.alarm_value" | transloco }}</mat-label>
    @if (isConditionFillLevel(selectedConditionField.value)) {
    <mat-select
      formControlName="alarmValue"
      [compareWith]="compareFillLevelOption">
      @for(option of fillLevelOptions; track option.value) {
      <mat-option [value]="option.value">{{
        option.translationKey | transloco
      }}</mat-option>
      }
    </mat-select>
    } @else {
    <input matInput formControlName="alarmValue" type="number" />
    }
    <mat-error>{{
      "automation_plans_form.no_alarm_value" | transloco
    }}</mat-error>
    @if(alarmValueField.value) {
    <mat-icon matSuffix class="loren-automation-plan-edit"> edit </mat-icon>
    }
  </mat-form-field>
  <div style="display: flex; flex-direction: column">
    <mat-form-field
      appearance="outline"
      class="loren-form-field loren-form-field-automation-plan"
      [ngClass]="{
        'loren-form-field-automation-plan--with-value': warningValueField.value
      }">
      <mat-label>{{
        "automation_plans_form.warning_value" | transloco
      }}</mat-label>
      @if (isConditionFillLevel(selectedConditionField.value)) {
      <mat-select
        formControlName="warningValue"
        [compareWith]="compareFillLevelOption">
        @for(option of fillLevelOptions; track option.value) {
        <mat-option [value]="option.value">{{
          option.translationKey | transloco
        }}</mat-option>
        }
      </mat-select>
      } @else {
      <input matInput type="number" formControlName="warningValue" />
      }
      @if(!confirmDeleteWarningValue()) {<mat-error>{{
        getWarningValueErrorMsg()
      }}</mat-error
      >} @if(warningValueField.value) {
      <div matSuffix style="display: flex; gap: 4px; margin: 0 4px">
        <mat-icon class="loren-automation-plan-edit"> edit </mat-icon>
        <mat-icon
          class="loren-automation-plan-edit"
          (click)="confirmDeleteWarningValue.set(true)">
          close
        </mat-icon>
      </div>
      }
    </mat-form-field>
    @if(confirmDeleteWarningValue()) {
    <div class="loren-automation-plan-confirm-delete">
      {{ "automation_plans_form.delete_confirm" | transloco }}
        <button
                matButton="filled"
                class="btn-error"
                (click)="warningValueField.reset(); confirmDeleteWarningValue.set(false)">
            {{ "automation_plans_form.confirm" | transloco }}
        </button>
        <button
                matButton="filled"
                class="btn-secondary"
                (click)="confirmDeleteWarningValue.set(false)">
            {{ "automation_plans_form.decline" | transloco }}
        </button>
    </div>
    }
  </div>
  } @if(selectedConditionField.value?.value &&
  isConditionGeofence($safeNavigationMigration(selectedConditionField.value?.value))) {
  <mat-form-field
    required
    appearance="outline"
    class="loren-form-field loren-form-field-automation-plan loren-automation-plan-grid-full-width"
    [ngClass]="{
      'loren-form-field-automation-plan--with-value': geozoneField.value
    }"
    [hideRequiredMarker]="false">
    <mat-label>{{ "automation_plans_form.geozone" | transloco }}</mat-label>
    <mat-select formControlName="geozone">
      @for(option of geofenceOptions; track option) {
      <mat-option [value]="$safeNavigationMigration(option?.value)"
        >{{ $safeNavigationMigration(option?.key) | transloco }}
      </mat-option>
      }
    </mat-select>
    <mat-error>{{ "automation_plans_form.no_geozone" | transloco }}</mat-error>
    @if(geozoneField.value) {
    <mat-icon matSuffix class="loren-automation-plan-edit"> edit </mat-icon>
    }
  </mat-form-field>
  } } @if(conditionForm.hasError('conditionExists')) {
  <p class="text-danger">
    {{ "automation_plans_form.condition_exists" | transloco }}
  </p>
  }

  <div
    class="loren-automation-plan-grid-full-width"
    style="display: flex; gap: 16px">
    <button
            matButton="filled"
      type="submit"
      class="loren-automation-plan-grid-full-width"
      [disabled]="conditionForm.invalid">
      {{
        (mode === "deleting"
          ? "automation_plans_form.delete"
          : "automation_plans_form.save"
        ) | transloco
      }}
    </button>
    @if(mode !== 'new') {
    <button
            matButton="filled"
      class="loren-automation-plan-grid-full-width btn-secondary"
      (click)="closeForm()">
      {{ "automation_plans_form.decline" | transloco }}
    </button>
    }
  </div>
</form>
